@if (this.tableDataSource && this.tableDataSource.data && sharedTableContent.columns && sharedTableContent.keys) {
<div class="bpx-toolbar shared-table__toolbar">
  <input type="search" class="bpx-input shared-table__filter" placeholder="Filter..."
    aria-label="Filter table" [(ngModel)]="filterText" (input)="filterData()">
  @if (showFailuresOnlyToggle && !forceFailuresOnly) {
    <mat-checkbox
      [(ngModel)]="failuresOnlyChecked"
      (change)="applyFilters()">
      Failures &amp; Discards Only
    </mat-checkbox>
  }
  @if (isSuperUser) {
    <div class="bpx-toolbar__actions">
      <button type="button" class="bpx-btn bpx-btn--icon" title="Download as CSV" [disabled]="csvExportDisabled"
        aria-label="Download as CSV" (click)="exportToCSV(exporter)">
        <mat-icon fontIcon="download"></mat-icon>
      </button>
    </div>
  }
</div>

<div class="bpx-table shared-table__card">
<table mat-table matSort [dataSource]="tableDataSource" #sharedTable class="shared-table"
  [class.shared-table--custom-pin]="pinnedColumnKeys.length > 0" matTableExporter
  #exporter="matTableExporter">
  @for (key of sharedTableContent.keys; track key) {    
  <ng-container matColumnDef="{{key}}">    
    <!-- <th mat-header-cell mat-sort-header *matHeaderCellDef  [ngClass]="getColumnClass(key)" -->
      <th mat-header-cell mat-sort-header *matHeaderCellDef class="col"
        [class]="pinClass(key)">
        {{sharedTableContent.columns[key]}}
        @if (dropdownFilterKeys.includes(key)) {
          <button class="col-filter-btn"
            [class.col-filter-btn--active]="isColumnFilterActive(key)"
            [matMenuTriggerFor]="columnFilterMenu"
            (click)="$event.stopPropagation()">
            <mat-icon>filter_list</mat-icon>
          </button>
          <mat-menu #columnFilterMenu="matMenu">
            <div class="col-filter-content" (click)="$event.stopPropagation()">
              <div class="col-filter-header">
                <mat-checkbox
                  [checked]="areAllSelected(key)"
                  [indeterminate]="isColumnFilterActive(key)"
                  (change)="toggleSelectAll(key)">
                  (Select All)
                </mat-checkbox>
              </div>
              <div class="col-filter-list">
                @for (val of getUniqueColumnValues(key); track val) {
                  <mat-checkbox
                    [checked]="isColumnValueChecked(key, val)"
                    (change)="toggleColumnValue(key, val)">
                    {{ val }}
                  </mat-checkbox>
                }
              </div>
            </div>
          </mat-menu>
        }
      </th>
    <td mat-cell *matCellDef="let element"
    [class]="pinClass(key)"
    [ngClass]="(customCssClassBinding(element, key) ? customCssClassBinding(element, key) : '') + ' ' + getCellClass(key)">
    @if (checkboxColumnKey && key === checkboxColumnKey) {
      <mat-checkbox
        color="warn"
        (click)="$event.stopPropagation()"
        [checked]="isCheckboxChecked(element)"
        [disabled]="isCheckboxDisabled(element)"
        (change)="onCheckboxChange(element, $event)">
      </mat-checkbox>
    } @else {
      {{formatCellValue(element[key])}}
    }
    </td>
  </ng-container>
  }

  <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayColumns" [ngClass]="{ 'fail-row': isFailOrAlertRow(row), 'discard-row': isDiscardedRow(row), 'outlier-row': isOutlierRow(row) }"></tr>
</table>
</div>
}
